<script lang="ts" setup>
  import * as locales from '@nuxt/ui/locale'

  // Props
  const props = withDefaults(defineProps<{
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }>(), {
    size: 'md'
  })

  // Idioma
  const { locale, setLocaleCookie, setLocale, availableLocales } = useI18n()
  
  const switchLocalePath = useSwitchLocalePath()

  // Filtrar locales de Nuxt UI para mostrar solo los configurados en i18n
  const filteredLocales = computed(() => {
    return Object.values(locales).filter((locale: any) => 
      availableLocales.includes(locale.code)
    )
  })

  // Manejar cambio de idioma
  const handleLocaleChange = (newLocale: string | undefined) => {
    if (!newLocale) return
    const localeCode = newLocale as 'es' | 'en' | 'de' | 'it' | 'fr'
    setLocale(localeCode)
    setLocaleCookie(localeCode)
    reloadNuxtApp({
      path: switchLocalePath(localeCode)
    })
  }
</script>

<template>
  <ULocaleSelect
    v-model="locale"
    :locales="filteredLocales"
    :size="size"
    v-bind="$attrs"
    @update:model-value="handleLocaleChange"
  />
</template>

